<app-dashboard-sidemenu></app-dashboard-sidemenu>

<!-- Start Main Content Wrapper Area -->
<div class="main-content d-flex flex-column">

  <app-dashboard-navbar></app-dashboard-navbar>

  <!-- Breadcrumb Area -->
  <!-- <div class="send-email-checker2"> -->
  <div class="breadcrumb-area" *ngFor="let Content of breadcrumb;">
    <h1>{{Content.title}}</h1>
    <ol class="breadcrumb">
      <li class="item"><a routerLink="/">Home</a></li>
      <li class="item"><a routerLink="/dashboard">{{Content.subTitle}}</a></li>
      <li class="item">{{Content.title}}</li>
    </ol>
  </div>
  <!-- </div> -->
  <!-- End Breadcrumb Area -->

  <!-- Start -->
  <div class="card finance-page">
    <p-table #dt2 [value]="jdedata" dataKey="supplierId" [rows]="10" responsiveLayout="scroll"
      [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,20,30,50]" [paginator]="true" currentPageReportTemplate="Showing {first} to
            {last} of {totalRecords} entries" [filterDelay]="0" [globalFilterFields]="['asnNumber','orderNumber',
            'ship' ,'value','supplierName','formattedInvoiceDate','asnStatus','checkerStatus']">
      <ng-template pTemplate="caption">
        <span class="p-input-icon-left d-flex align-items-center">
          <i class="pi pi-search"></i>
          <input pInputText type="text" (input)="dt2.filterGlobal($event.target.value,
                        'contains')" placeholder="Global Search" [(ngModel)]="filterval" />
          <p-button type="button" class="ml-2" (click)="reset()" icon="bx bx-reset"></p-button>
          <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="onXLSExport()"
            class="p-button-success mr-2" pTooltip="XLS" tooltipPosition="bottom" style="margin-left: 8px;"></button>

          <!-- Status Dropdown -->
          <div class="ml-3 d-flex align-items-center" style="margin-left: 15px;">
            <select class="form-select form-control" [(ngModel)]="selectedPayloadStatus" (change)="getdata()"
              style="width: auto; min-width: 150px; display: inline-block;">
              <option [ngValue]="null">All Status</option>
              <option *ngFor="let statusObj of payloadStatuses" [value]="statusObj.value">{{ statusObj.label }}</option>
            </select>
          </div>

        </span>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th>S.No.</th>
          <th>Action</th>
          <th>Status</th>
          <th>Invoice No</th>
          <th>Invoice Date</th>
          <th *ngIf="this.userroleName.roleName !== 'Supplier'">MRA Status</th>
          <th *ngIf="this.userroleName.roleName !== 'Supplier'">MRA Remark</th>
          <th>ASN Number</th>
          <th>Order No</th>
          <th>Ship Qty</th>
          <th>Total Amount</th>
          <th>Supplier Name</th>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td style="padding: 4px;">
            <input pInputText type="text" (input)="dt2.filter($event.target.value,
          'asnStatus',  'contains')" placeholder="Keyword" [(ngModel)]="status" />
          </td>
          <td style="padding: 4px;">
            <input pInputText type="text" (input)="dt2.filter($event.target.value,
          'invoiceNumber',  'contains')" placeholder="Keyword" [(ngModel)]="invoiceNumber" />
          </td>
          <td style="padding: 4px;">
            <input pInputText type="text" (input)="dt2.filter($event.target.value,
        'formattedInvoiceDate',  'contains')" placeholder="Keyword" [(ngModel)]="invoicedate" />
          </td>
          <td style="padding: 4px;" *ngIf="this.userroleName.roleName!=='Supplier'">
            <input pInputText type="text" (input)="dt2.filter($event.target.value,
          'checkerStatus',  'contains')" placeholder="Keyword" [(ngModel)]="mrastatus" />
          </td>
          <td style="padding: 4px;" *ngIf="this.userroleName.roleName!=='Supplier'">
            <input pInputText type="text" (input)="dt2.filter($event.target.value,
          'remark',  'contains')" placeholder="Keyword" [(ngModel)]="mraremark" />
          </td>
          <td style="padding: 4px;">
            <input pInputText type="text" (input)="dt2.filter($event.target.value,
          'asnNumber',  'contains')" placeholder="Keyword" [(ngModel)]="asnumber" />
          </td>
          <td style="padding: 4px;">
            <input pInputText type="text" (input)="dt2.filter($event.target.value,
          'orderNumber',  'contains')" placeholder="Keyword" [(ngModel)]="orderno" />
          </td>
          <td style="padding: 4px;">
            <input pInputText type="text" (input)="dt2.filter($event.target.value,
          'ship',  'gt')" placeholder="Keyword" [(ngModel)]="shipqty" />
          </td>
          <td style="padding: 4px;">
            <input pInputText type="text" (input)="dt2.filter($event.target.value,
          'totalAmount',  'contains')" placeholder="Keyword" [(ngModel)]="orderCo" />
          </td>

          <td>
            <input pInputText type="text" (input)="dt2.filter($event.target.value,
      'supplierName',  'contains')" placeholder="Keyword" [(ngModel)]="shipToName" />
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-jde let-i="rowIndex">
        <tr class="p-selectable-row">

          <td>{{i+1}}</td>
          <td class="d-flex" style="text-align: center;">
            <button pButton pRipple pTooltip="Show ASN Details" type="button" icon="bx bx-show" class="p-button-rounded p-button-primary
                p-button-text" (click)="openModal(jde)"></button>

            <button *ngIf="this.userroleName.roleName == 'Admin' && jde.checkerStatus != 'AT PV Approval'" pButton
              pRipple type="button" icon="bx bx-trash" class="p-button-rounded p-button-danger
                p-button-text" [disabled]="jde.isDeleted" (click)="confirmDelete(jde.asnNumber)"></button>

            <!-- <button pButton pRipple pTooltip="Edit ASN" type="button" icon="bx bx-edit" class="p-button-rounded p-button-warning
                p-button-text" (click)="editasn(jde)"></button> -->
          </td>

          <!-- <td>
            <button pButton pRipple type="button" *ngIf="jde.asnStatus == 'ASNGenerated'" [label]="'ASN Generated'"
              class="p-button-rounded
                p-button-success status_button"></button>
            <button pButton pRipple type="button" *ngIf="jde.asnStatus == 'Pending'" label="Pending" disabled
              class="p-button-rounded status_button pending"></button>
            <button pButton pRipple type="button" *ngIf="jde.asnStatus == 'Rework'" [label]="jde.asnStatus" class="p-button-rounded p-button-info
                status_button"></button>
            <button pButton pRipple type="button" *ngIf="jde.asnStatus == 'Rejected'" [label]="jde.status" class="p-button-rounded p-button-danger
                status_button"></button>
            <button pButton pRipple type="button" *ngIf="jde.asnStatus == 'Material Inward'" [label]="'Material Inward'"
              class="p-button-rounded
                p-button-primary status_button"></button>
            <button pButton pRipple type="button" *ngIf="jde.asnStatus == 'Partial GRN'" [label]="'Partial GRN'"
              disabled class="p-button-rounded status_button pending"></button>
            <button pButton pRipple type="button" *ngIf="jde.asnStatus == 'Fully Receipt'" [label]="jde.asnStatus"
              disabled class="p-button-rounded
                p-button-success status_button"></button>
            <button pButton pRipple type="button" *ngIf="jde.asnStatus == 'Approved for MRA'"
              [label]="'Approved for MRA'" class="p-button-rounded
                p-button-success status_button"></button>
            <span *ngIf="jde.status == ''">-</span>
          </td> -->
          <td>
            <!-- Deleted status (highest priority) -->
            <button pButton pRipple type="button" *ngIf="jde.isDeleted" label="Deleted"
              class="p-button-rounded p-button-danger status_button">
            </button>

            <!-- Existing statuses -->
            <button pButton pRipple type="button" *ngIf="!jde.isDeleted && jde.asnStatus == 'ASNGenerated'"
              [label]="'ASN Generated'" class="p-button-rounded p-button-success status_button"></button>

            <button pButton pRipple type="button" *ngIf="!jde.isDeleted && jde.asnStatus == 'Pending'" label="Pending"
              disabled class="p-button-rounded status_button pending"></button>

            <button pButton pRipple type="button" *ngIf="!jde.isDeleted && jde.asnStatus == 'Rework'"
              [label]="jde.asnStatus" class="p-button-rounded p-button-info status_button"></button>

            <button pButton pRipple type="button" *ngIf="!jde.isDeleted && jde.asnStatus == 'Rejected'"
              [label]="jde.status" class="p-button-rounded p-button-danger status_button"></button>

            <button pButton pRipple type="button" *ngIf="!jde.isDeleted && jde.asnStatus == 'Material Inward'"
              [label]="'Material Inward'" class="p-button-rounded p-button-primary status_button"></button>

            <button pButton pRipple type="button" *ngIf="!jde.isDeleted && jde.asnStatus == 'Partial GRN'"
              [label]="'Partial Receipt'" disabled class="p-button-rounded status_button pending"></button>

            <button pButton pRipple type="button" *ngIf="!jde.isDeleted && jde.asnStatus == 'Fully Receipt'"
              [label]="jde.asnStatus" disabled class="p-button-rounded p-button-success status_button"></button>

            <button pButton pRipple type="button" *ngIf="!jde.isDeleted && jde.asnStatus == 'Approved for MRA'"
              [label]="'Approved for MRA'" class="p-button-rounded p-button-success status_button"></button>
            <button pButton pRipple type="button" *ngIf="!jde.isDeleted && jde.asnStatus == 'Partial Inward'"
              [label]="'Partial Inward'" class="p-button-rounded p-button-primary status_button"></button>

            <span *ngIf="!jde.isDeleted && jde.status == ''">-</span>
          </td>
          <td>{{jde.invoiceNumber ? jde.invoiceNumber : '-'}}</td>
          <td>{{jde.formattedInvoiceDate || '-'}}</td>
          <td *ngIf="this.userroleName.roleName !=='Supplier'">
            <button pButton pRipple type="button" *ngIf="jde.checkerStatus == 'Approved for MRA'"
              [label]="jde.checkerStatus" class="p-button-rounded
                p-button-success status_button"></button>
            <button pButton pRipple type="button" *ngIf="jde.checkerStatus == 'Pending'" label="Pending" disabled
              class="p-button-rounded status_button pending"></button>
            <button pButton pRipple type="button" *ngIf="jde.checkerStatus == 'Rework'" [label]="jde.checkerStatus"
              class="p-button-rounded p-button-info
                status_button"></button>
            <button pButton pRipple type="button" *ngIf="jde.checkerStatus == 'Rejected'" [label]="jde.checkerStatus"
              class="p-button-rounded p-button-danger
                status_button"></button>
            <button pButton pRipple type="button" *ngIf="jde.checkerStatus == 'Reworked but not Reviewed'"
              [label]="jde.checkerStatus" class="p-button-rounded
                p-button-primary status_button"></button>
            <button pButton pRipple type="button" *ngIf="jde.checkerStatus == 'AT PV Approval'"
              [label]="jde.checkerStatus" class="p-button-rounded
                p-button-primary status_button"></button>
            <button pButton pRipple type="button" *ngIf="jde.checkerStatus == 'Partial GRN'" [label]="'Partial Receipt'"
              disabled class="p-button-rounded status_button pending"></button>
            <button pButton pRipple type="button" *ngIf="jde.checkerStatus == 'Fully Receipt'" [label]="'Fully Receipt'"
              disabled class="p-button-rounded
                p-button-success status_button"></button>
            <button pButton pRipple type="button" *ngIf="jde.checkerStatus == 'Partial Inward'"
              [label]="'Partial Inward'" class="p-button-rounded p-button-primary status_button"></button>
            <span *ngIf="jde.checkerStatus == ''">-</span>
          </td>
          <td *ngIf="this.userroleName.roleName !=='Supplier'">{{jde.remark ? jde.remark : '-'}}</td>
          <td>{{jde.asnNumber ? jde.asnNumber : '-'}}</td>
          <td>{{jde.orderNumber ? jde.orderNumber : '-'}}</td>
          <td>{{jde.ship ? jde.ship : '-'}}</td>
          <td>{{jde.totalAmount ? jde.totalAmount : '-'}}</td>

          <td>{{jde.supplierName|| '-'}}</td>


        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="10">No ASN found.</td>
        </tr>
      </ng-template>
    </p-table>
    <div class="flex-grow-1"></div>
  </div>
  <!-- End -->
  <p-dialog header="ASN Details" [(visible)]="display" [modal]="true" appendTo="body" [style]="{width: '90vw'}"
    [draggable]="false" [resizable]="false">
    <div class="table-scroll-container mb-3 shadow-sm rounded"
      style="max-height: 33vh; overflow: auto; border: 1px solid #dee2e6;">
      <table class="table table-bordered asnTable mb-0">
        <thead>
          <tr>
            <th></th>
            <th>Item Number</th>
            <th>Item </th>
            <th>LN No</th>
            <th>Order No</th>
            <!-- <th>Invoice No</th> -->
            <!-- <th>Invoice Date</th> -->
            <th>Ship Qty</th>
            <th>GRN Qty</th>
            <th>Pending GRN Qty</th>
            <th>Grn status</th>
            <th>Total Value</th>

            <th>
              <div class="d-flex justify-content-between align-items-center">
                <span>Value Stream</span>
                <button *ngIf="showApplyToAllButton" class="btn btn-sm btn-outline-primary"
                  style="font-size: 12px; padding: 2px 8px;" (click)="applyValueStreamToAll()">
                  Apply "{{ selectedValueStreamToApply }}" to All
                </button>
              </div>
            </th>
            <th>Order Type</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let jde of selectedJdeList">
            <td>
              <input type="checkbox" [(ngModel)]="jde.selected" [disabled]="
      !(jde.grnPendingStatus === 2 && jde.checkerStatus === 'Partial GRN'||jde.checkerStatus === 'Partial Inward') && jde.isApproved
    " />
            </td>
            <td>{{jde.itemnumber || '-'}}</td>

            <td>{{jde.itemdesc || '-'}}</td>
            <td>{{jde.linenumber || '-'}}</td>
            <td>{{ jde.orderNumber || '-' }}</td>
            <!-- <td>{{ jde.invoiceNumber || '-' }}</td> -->
            <!-- <td>
              <input type="text" name="myInput" class="form-control" style="border: none;" placeholder="Enter Invoice"
                maxlength="10" [(ngModel)]="jde.invoiceNumber">
            </td> -->


            <!-- <td>{{jde.invoiceDate ? (jde.invoiceDate | date: 'dd/MM/yy'): '-'}}</td> -->
            <!-- <td (click)="enableEdit()" style="cursor: pointer;">

         
              <span *ngIf="!isEditing">
                {{ jde.invoiceDate | date:'dd/MM/yy' }}
              </span>

  
              <input *ngIf="isEditing" type="date" [(ngModel)]="jde.invoiceDate" (blur)="disableEdit()"
                (keyup.enter)="disableEdit()" />
            </td> -->

            <td>{{ jde.ship || '-' }}</td>
            <td>
              <input type="text" name="myInput" class="form-control" style="border: none;" placeholder="Enter GRN"
                [disabled]="userroleName.roleName === 'Supplier' || jde._originalGrnPendingStatus === 2"
                [(ngModel)]="jde.grnQty" (ngModelChange)="onGrnQtyChange(jde)">



            </td>
            <td>
              <input type="text" name="myInput" class="form-control" style="border: none;" placeholder="Enter Pending"
                readonly [(ngModel)]="jde.grnPendingQty">

            </td>
            <td>
              <select style="border:none" [(ngModel)]="jde.grnPendingStatus" (ngModelChange)="onGrnStatusChange(jde)" class="form-control"
                name="grnPendingStatus" required [disabled]="userroleName.roleName === 'Supplier' || !jde.grnQty">
                <option value="">-- Select Status --</option>
                <option *ngFor="let status of grnstatus" [value]="status.id">
                  {{ status.value }}
                </option>
              </select>
              <div *ngIf="!jde.grnPendingStatus" class="invalid-feedback">
                Status is required
              </div>
            </td>
            <td>{{ jde.value || '-' }}</td>
            <td>
              <select [disabled]="jde.isApproved" style="border:none" [(ngModel)]="jde.valueStream2"
                (ngModelChange)="onValueStreamChange(jde)" class="form-control" name="valueStreamSelect">
                <option value="">-- Select Value Stream --</option>
                <option *ngFor="let stream of valueStreamdropdown" [value]="stream.valueStreamName">
                  {{ stream.valueStreamName }}
                </option>
              </select>
            </td>

            <td>{{jde.ordertype || '-'}}</td>
          </tr>
        </tbody>

      </table>
    </div>

    <!-- Quick Action Buttons at Top (safe navigation to avoid checkerStatus undefined error) -->
    <div class="d-flex justify-content-end align-items-center gap-3 mt-2 mb-3 px-1"
      *ngIf="selectedJdeList?.length > 0 && !(userroleName.roleName === 'Supplier' || userroleName.checker1 || userroleName.roleName === 'Finance')">
      <button class="btn btn-outline-danger shadow-sm d-flex align-items-center justify-content-center gap-2"
        type="button" (click)="btnClick('reject')"
        [disabled]="selectedJdeList[0]?.checkerStatus !== 'Pending' || selectedASN?.isDeleted"
        style="padding: 7px 22px; border-radius: 8px; font-weight: 600; font-size: 13px; transition: all 0.2s;">
        <i class="bx bx-x-circle" style="font-size: 16px;"></i> Rework
      </button>
      <button class="btn btn-success shadow-sm d-flex align-items-center justify-content-center gap-2 text-white"
        type="button" (click)="btnClick('approve')"
        [disabled]="(!(selectedASN?.grnPendingStatus === 2 && selectedJdeList[0]?.checkerStatus === 'Partial GRN' || selectedJdeList[0]?.checkerStatus === 'Partial Inward') && (selectedJdeList[0]?.checkerStatus !== 'Pending' && userroleName.roleName !== 'Finance')) || selectedASN?.isDeleted"
        style="background: linear-gradient(135deg, #10b981 0%, #059669 100%); border: none; padding: 7px 22px; border-radius: 8px; font-weight: 600; font-size: 13px; transition: all 0.2s;">
        <i class="bx bx-check-circle" style="font-size: 16px;"></i> Approve
      </button>
    </div>

    <!-- Details Section Fixed at Bottom -->
    <div class="asn-details-footer p-2" style="background: #fff; border-radius: 8px;">



      <div class="row mt-4 px-2" *ngIf="selectedJdeList.length > 0">
        <!-- Modern Document Buttons -->
        <div class="col-lg-2 col-md-6 form-group mb-3">
          <label class="d-block mb-2"
            style="color: #6c757d; font-weight: 600; font-size: 11px; text-transform: uppercase; letter-spacing: 0.5px;">Invoice
            Document</label>
          <a *ngIf="selectedJdeList[0].invoicePath" [href]="selectedJdeList[0].invoicePath" target="_blank"
            [download]="selectedJdeList[0].invoicePath"
            class="btn btn-outline-primary w-100 d-flex align-items-center justify-content-center shadow-sm"
            style="border-radius: 6px; padding: 8px; font-size: 13px; gap: 6px; transition: 0.2s;"><i
              class="bx bx-file"></i> Preview</a>
          <div *ngIf="!selectedJdeList[0].invoicePath" class="text-center text-muted w-100"
            style="padding: 8px; background: #f8f9fa; border: 1px dashed #dee2e6; border-radius: 6px; font-size: 13px;">
            No Document</div>
        </div>

        <div class="col-lg-2 col-md-6 form-group mb-3">
          <label class="d-block mb-2"
            style="color: #6c757d; font-weight: 600; font-size: 11px; text-transform: uppercase; letter-spacing: 0.5px;">Delivery
            Challan</label>
          <a *ngIf="selectedJdeList[0].deliveryChaalanPath" [href]="selectedJdeList[0].deliveryChaalanPath"
            target="_blank" [download]="selectedJdeList[0].deliveryChaalanPath"
            class="btn btn-outline-primary w-100 d-flex align-items-center justify-content-center shadow-sm"
            style="border-radius: 6px; padding: 8px; font-size: 13px; gap: 6px; transition: 0.2s;"><i
              class="bx bx-file"></i> Preview</a>
          <div *ngIf="!selectedJdeList[0].deliveryChaalanPath" class="text-center text-muted w-100"
            style="padding: 8px; background: #f8f9fa; border: 1px dashed #dee2e6; border-radius: 6px; font-size: 13px;">
            No Document</div>
        </div>

        <div class="col-lg-2 col-md-6 form-group mb-3">
          <label class="d-block mb-2"
            style="color: #6c757d; font-weight: 600; font-size: 11px; text-transform: uppercase; letter-spacing: 0.5px;">Eway
            Bill</label>
          <a *ngIf="selectedJdeList[0].ewayBillPath" [href]="selectedJdeList[0].ewayBillPath" target="_blank"
            [download]="selectedJdeList[0].ewayBillPath"
            class="btn btn-outline-primary w-100 d-flex align-items-center justify-content-center shadow-sm"
            style="border-radius: 6px; padding: 8px; font-size: 13px; gap: 6px; transition: 0.2s;"><i
              class="bx bx-file"></i> Preview</a>
          <div *ngIf="!selectedJdeList[0].ewayBillPath" class="text-center text-muted w-100"
            style="padding: 8px; background: #f8f9fa; border: 1px dashed #dee2e6; border-radius: 6px; font-size: 13px;">
            No Document</div>
        </div>

        <div class="col-lg-3 col-md-6 form-group mb-3">
          <label class="d-block mb-2"
            style="color: #6c757d; font-weight: 600; font-size: 11px; text-transform: uppercase; letter-spacing: 0.5px;">Invoice
            Number</label>
          <input type="text" name="myInput" class="form-control shadow-sm"
            style="border: 1px solid #ced4da; border-radius: 6px; padding: 8px; background-color: #fff;"
            placeholder="Enter Invoice" maxlength="10" [(ngModel)]="selectedJdeList[0].invoiceNumber"
            [disabled]="userroleName.roleName !== 'Store' || 
           (selectedJdeList[0].checkerStatus !== 'Pending' && 
            selectedJdeList[0].checkerStatus !== 'Partial GRN')">
        </div>

        <div class="col-lg-3 col-md-6 form-group mb-3">
          <label class="d-block mb-2"
            style="color: #6c757d; font-weight: 600; font-size: 11px; text-transform: uppercase; letter-spacing: 0.5px;">Invoice
            Date</label>
          <input type="date" name="invoiceDate" class="form-control shadow-sm"
            style="border: 1px solid #ced4da; border-radius: 6px; padding: 8px; background-color: #fff;"
            [(ngModel)]="selectedJdeList[0].invoiceDate"
            [disabled]="userroleName.roleName !== 'Store' || selectedJdeList[0].checkerStatus !== 'Pending'">
        </div>

        <div class="col-lg-4 col-md-12 form-group mb-3"
          *ngIf="hasPartialGRN() && (selectedJdeList[0].creditNotePath || userroleName.roleName === 'Supplier')">
          <label class="d-block mb-2"
            style="color: #6c757d; font-weight: 600; font-size: 11px; text-transform: uppercase; letter-spacing: 0.5px;">Credit
            Note</label>
          <ng-container *ngIf="!selectedJdeList[0].creditNotePath && userroleName.roleName === 'Supplier'">
            <div class="d-flex align-items-center gap-2">
              <input type="file" class="form-control shadow-sm w-100" style="border-radius: 6px; padding: 5px;"
                name="creditNote" (change)="onCreditNoteFileSelected($event)" />
              <button type="button" class="btn btn-success shadow-sm"
                style="white-space: nowrap; border-radius: 6px; padding: 6px 15px;" (click)="submitCreditNote()"><i
                  class="bx bx-upload"></i> Upload</button>
            </div>
            <div class="invalid-feedback">Please Upload Document</div>
          </ng-container>
          <a *ngIf="selectedJdeList[0].creditNotePath" [href]="selectedJdeList[0].creditNotePath" target="_blank"
            class="btn btn-outline-primary w-100 d-flex align-items-center justify-content-center shadow-sm"
            style="border-radius: 6px; padding: 8px; font-size: 13px; gap: 6px;"><i class="bx bx-file"></i> Preview</a>
        </div>

        <div class="col-lg-8 col-md-12 form-group mb-3">
          <label class="d-block mb-2"
            style="color: #6c757d; font-weight: 600; font-size: 11px; text-transform: uppercase; letter-spacing: 0.5px;">Additional
            Documents:</label>
          <div class="d-flex flex-wrap" style="gap: 8px;">
            <!-- Fix for empty check: Using length variable to show fallback if empty -->
            <span *ngFor="let request of selectedJdeList[0].asnrequest; let i = index">
              <ng-container *ngFor="let doc of getDocumentPaths(request); let j = index">
                <a [href]="doc.path" target="_blank" [download]="doc.path"
                  class="badge text-decoration-none shadow-sm d-inline-flex align-items-center"
                  style="background-color: #f8f9fa; color: #495057; padding: 8px 12px; font-weight: 500; font-size: 12px; border: 1px solid #dee2e6;"><i
                    class="bx bx-link-external mr-1"></i> {{ doc.label }}</a>
              </ng-container>
            </span>
            <div *ngIf="!selectedJdeList[0].asnrequest || selectedJdeList[0].asnrequest.length === 0"
              class="text-muted w-100 text-center"
              style="font-size: 13px; background: #f8f9fa; padding: 6px 12px; border-radius: 6px; border: 1px dashed #dee2e6;">
              No Additional Documents</div>
          </div>
        </div>

        <!-- Remark: always visible so users can see the reason/remark for this ASN -->
        <div class="col-lg-4 col-md-12 form-group mb-3" *ngIf="hasPartialGRN() && (selectedJdeList[0].creditNotePath || userroleName.roleName === 'Supplier')">
          <label class="d-block mb-2"
            style="color: #6c757d; font-weight: 600; font-size: 11px; text-transform: uppercase; letter-spacing: 0.5px;">Remark</label>
          <div class="w-100"
            style="padding: 8px 12px; background: #f8f9fa; border: 1px solid #dee2e6; border-radius: 6px; font-size: 13px; color: #495057; min-height: 38px;">
            {{ selectedJdeList[0].remark || 'No Remark' }}
          </div>
        </div>

        <div class="col-12 mt-2">
          <div class="row align-items-start">
            <div class="col-lg-7">
              <div class="row p-3 shadow-sm mx-1"
                style="background: rgba(248, 249, 250, 0.5); border: 1px solid #edf2f7; border-radius: 8px;">
                <div class="col-lg-6 col-md-12 form-group mb-0"
                  *ngIf="userroleName.roleName === 'Admin' || userroleName.roleName === 'Store'">
                  <label class="d-block mb-2"
                    style="color: #495057; font-weight: 600; font-size: 12px;">Remark/Reason<span
                      class="star_class text-danger">*</span>:</label>
                 <input type="text"
       placeholder="Add remark..."
       [formControl]="ApprovedRemark"
       class="form-control shadow-sm"
       [ngClass]="{'is-invalid': ApprovedRemark.touched && ApprovedRemark.invalid}" />

<div *ngIf="ApprovedRemark.touched && ApprovedRemark.invalid"
     class="text-danger"
     style="font-size: 12px; margin-top: 4px;">
  Remark/Reason is required
</div>
                </div>
                <div class="col-lg-6 col-md-12 form-group mb-0"
                  *ngIf="userroleName.roleName === 'Admin'|| userroleName.roleName === 'Finance'">
                  <label class="d-block mb-2" style="color: #495057; font-weight: 600; font-size: 12px;">TDS
                    Type</label>
                  <select class="form-control form-select shadow-sm" [(ngModel)]="selectedJdeList.tdsType"
                    style="border-radius: 6px; border: 1px solid #ced4da;">
                    <option [ngValue]="null" disabled>Select TDS Type</option>
                    <option *ngFor="let tds of tdsdropdown" [ngValue]="tds.tdsType">{{ tds.tdsTypeName }}</option>
                  </select>
                </div>
              </div>
            </div>

            <!-- Tax Section High Fidelity Card -->
            <div class="col-lg-5 d-flex justify-content-end form-group mb-0 mt-3 mt-lg-0">
              <div class="shadow-sm w-100"
                style="background: linear-gradient(145deg, #ffffff, #f8fafc); border-radius: 10px; border: 1px solid #e2e8f0; max-width: 360px; overflow: hidden;">
                <div style="background-color: #f1f5f9; padding: 10px 15px; border-bottom: 1px solid #e2e8f0;">
                  <strong style="color: #475569; font-size: 13px; text-transform: uppercase;">Financial Summary</strong>
                </div>
                <div class="p-3">
                  <div class="d-flex justify-content-between mb-2" style="font-size: 14px;">
                    <span style="color: #64748b; font-weight: 500;">Value (Excl. Tax):</span>
                    <span style="font-weight: 600; ">{{ calculateTotalShipAmount() | number:'1.2-2'
                      }}</span>
                  </div>
                  <div class="d-flex justify-content-between mb-2" style="font-size: 14px;">
                    <span style="color: #64748b; font-weight: 500;">Tax Amount:</span>
                    <span style="font-weight: 600">+ {{ calculateTotalTaxAmount() | number:'1.2-2'
                      }}</span>
                  </div>
                  <div style="border-top: 1px dashed #cbd5e1; margin: 12px 0;"></div>
                  <div class="d-flex justify-content-between align-items-center">
                    <strong style="font-size: 15px; color: #1e293b;">Total (Incl. Tax):</strong>
                    <strong style="font-size: 18px; color: #10b981;">{{ calculateTotalAmountWithTax() | number:'1.2-2'
                      }}</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="col-lg-12 mt-4 pt-4 border-top"
          *ngIf="!(userroleName.roleName === 'Supplier'|| userroleName.checker1||  userroleName.roleName === 'Finance')">
          <div class="d-flex justify-content-end align-items-center gap-3">
            <button class="btn btn-outline-danger shadow-sm d-flex align-items-center justify-content-center gap-2"
              type="submit" (click)="btnClick('reject')"
              [disabled]="selectedASN.checkerStatus !== 'Pending' || selectedASN.isDeleted"
              style="padding: 10px 30px; border-radius: 8px; font-weight: 600; transition: all 0.2s;">
              <i class="bx bx-x-circle" style="font-size: 18px;"></i> Rework
            </button>
            <button class="btn btn-success shadow-sm d-flex align-items-center justify-content-center gap-2 text-white"
              type="submit" (click)="btnClick('approve')"
              [disabled]="(!(selectedASN.grnPendingStatus === 2 && selectedASN.checkerStatus === 'Partial GRN'||selectedASN.checkerStatus === 'Partial Inward') && (selectedASN.checkerStatus !== 'Pending' && userroleName.roleName !== 'Finance')) || selectedASN.isDeleted"
              style="background: linear-gradient(135deg, #10b981 0%, #059669 100%); border: none; padding: 10px 30px; border-radius: 8px; font-weight: 600; transition: all 0.2s;">
              <i class="bx bx-check-circle" style="font-size: 18px;"></i> Approve
            </button>
          </div>
        </div> -->
      </div>
    </div>
  </p-dialog>

  <p-dialog header="Upload Credit Note" [(visible)]="displaycredit" [modal]="true" appendTo="body"
    [style]="{width: '35vw'}" [draggable]="false" [resizable]="false" (onHide)="resetform()">
    <form [formGroup]="toolLoanForm" (ngSubmit)="submitForm()" #register="ngForm">
      <div class="add-listings-box1">
        <div class="row">
          <div class="col-lg-6 col-md-12 form-group">
            <label>Upload Credit Note<span class="star_class">*</span></label>
            <input #fileInput type="file" class="form-control" formControlName="uploadDoc" [class.is-invalid]="(register.submitted &&
					 toolLoanForm.get('uploadDoc')?.invalid) ||
					 (toolLoanForm.get('uploadDoc')?.touched &&
					 toolLoanForm.get('uploadDoc')?.invalid)" (change)="getFile($event)" required>
            <div class="invalid-feedback">Please Upload Document</div>

          </div>

        </div>
        <div class="form-group">
          <button type="submit" class="submit_btn">Upload</button>

        </div>
      </div>
    </form>
  </p-dialog>
  <app-copyrights></app-copyrights>

</div>